import { create } from "zustand";

export const useWebSiteStore = create((set: any) => ({
  webSite: false,
  setWebSite: (error: any) => set({ webSite: error }),
}));
